'use client'

import Section from '@lyra/core/components/Section'

export default function Loading() {
  return (
    <Section flexGrow={1} flexShrink={1} justifyContent="center" alignItems="center">
      <Section.Spinner />
    </Section>
  )
}
